<script lang="ts" setup>
import { getAccountPermalink } from '~/lib'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const { open } = useLoginModal()
const { isLoggedIn } = useUser()

const onClick = () => {
  if (!isLoggedIn.value) return open()

  navigateTo(getAccountPermalink())
}
</script>
<template>
  <ClientOnly>
    <HeaderActionButton
      :class="['desktop-only', 'hover', { 'is-logged-in': isLoggedIn }]"
      :aria-label="isLoggedIn ? t('account.label') : t('login')"
      @click="onClick"
    >
      <Icon name="profile" />
    </HeaderActionButton>
    <template #fallback>
      <!-- Show a neutral state during SSR -->
      <HeaderActionButton class="desktop-only hover" :aria-label="t('login')" @click="open">
        <Icon name="profile" />
      </HeaderActionButton>
    </template>
  </ClientOnly>
  <ShopLoginModal />
</template>
<style lang="scss" scoped>
.button {
  &.is-logged-in {
    color: var(--c-red-100);
  }
}
</style>
